import RotateScreenMessage from "./RotateScreenMessage";

export default RotateScreenMessage;